import remoteTimeNow from 'libs/remote-time-now';
import moment from 'moment';

const isGroupVideoCallDisabled = (config: any = {}) => {
  if (config.isGroupVideoCallDisabled) return true;
  const periods = config.enableGroupVideoCallPeriods || [];
  if (periods.length === 0) return false;
  const now = remoteTimeNow();
  return !periods.some(({ from, to }) => now.isBetween(moment(from), moment(to)));
};

export default isGroupVideoCallDisabled;
